import cn from 'classnames';
import { camelCase, toUpper } from 'lodash';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import { DrawerProvider } from '../../drawer';
import { Column } from '../../layout';
import { ModalProvider } from '../../modal';
import { useFormContext } from '../context-provider/FormProvider';
import { Detail } from './Detail';
import { List } from './List';
import { useListAndDetailContext } from './ListAndDetailProvider';

const Styled = styled(Column)`
  padding: 5px;
  gap: 0;
  .ant-drawer-body {
    display: flex;
  }
`;

// TODO get formConfig from formContext.
const pascalCase = str => camelCase(str).replace(/^(.)/, toUpper);

export const View = () => {
  const { config } = useListAndDetailContext();
  const { Components } = useFormContext();

  const FormComponent = React.useMemo(() => {
    const name = config.name || config.path;
    return Components[pascalCase(name)];
  }, [Components, config.name, config.path]);

  return (
    <Styled className={cn('services')}>
      <FormComponent>
        <ModalProvider>
          <DrawerProvider>
            <Routes>
              <Route path="" element={<List />} />
              <Route path="detail/*" element={<Detail />} />
            </Routes>
          </DrawerProvider>
        </ModalProvider>
      </FormComponent>
    </Styled>
  );
};
